import React, { useEffect, useState } from 'react'

import styles from "./styles/Lobby.module.scss"

import _ from 'lodash'
import { Container, Spinner } from 'react-bootstrap'
import { useMutation, useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { QuizAPI } from '../../Api/Quiz'
import { Button, Description, DescriptionLight, Header, Headline, LabelHeader } from '../../Components/CustomComponent'
import Accordian from '../../Components/CustomComponent/Accordian'
import TimerNavbar from '../../Components/Layouts/TimerNavbar'
import { useAppContext } from '../../Context/AppContext'
import { useSocket } from '../../Context/SocketContext'
import { ACCOUNT_ENUM } from './Route'

export default function Lobby({ data, setPage }) {
    const navigate = useNavigate()
    const quizAPI = QuizAPI()
    const socket = useSocket()
    const { user: { id }, isSocketConnected } = useAppContext();

    const [isSubmitted, setIsSubmitted] = useState(false)

    const { data: lobbyUsers, isFetching, refetch } = useQuery(
        ['quiz', data.id, 'lobby', 'users'],
        async () => await quizAPI.getQuizLobbyUser(data.id)
    );


    const quizMutation = useMutation(quizAPI.start, {
        onSuccess: ({ data }) => {
            console.log("Quiz API data : ", data)
        },
        onError: (err) => {
            setIsSubmitted(false)
        }
    })

    useEffect(() => {
        if (!isSocketConnected) return;

        socket.on('_quizStarted', (data) => {

            setPage(ACCOUNT_ENUM.GAME, data)
        })

        socket.on('_newMemberJoined', () => {
            refetch()
        })

        socket.on('_memberLeaved', () => {
            refetch()
        })

        return () => {
            if (isSocketConnected) {
                socket.dispose('_quizStarted')
                socket.dispose('_newMemberJoined')
                socket.dispose('_memberLeaved')
            }
        }
    }, [isSocketConnected])


    const handleClose = () => {
        navigate(-1, { replace: true })
    }

    const handleLeaveQuiz = () => {
        navigate(-1, { replace: true })

    }

    const handleStartQuiz = () => {
        if (isSubmitted) return;
        setIsSubmitted(true)

        quizMutation.mutate(data.id);
    }

    return (
        <Container className={styles.Lobby}>
            <img src="/assets/quiz-cover.jpg" alt="Quiz Cover" className={styles.quizCover} />

            <div className={styles.content}>
                <TimerNavbar isTimer={false} isCoins={false} onClose={handleClose} />
                <Header
                    text="Quiz Lobby"
                />
                <div className='d-flex flex-column gap-1 my-3'>
                    <span className="d-flex gap-2 align-items-center">
                        <Description
                            text='Title:'
                        />
                        <DescriptionLight
                            size='6'
                            text={data.title}
                        />
                    </span>
                    <span className="d-flex gap-2 align-items-center">
                        <Description
                            text='Host:'
                        />
                        <DescriptionLight
                            size='6'
                            text={data.quiz_host?.name || ''}
                        />
                    </span>
                    <span className="d-flex gap-2 align-items-center">
                        <Description
                            text='Quiz Code:'
                        />
                        <DescriptionLight
                            size='6'
                            text={data.code}
                        />
                    </span>
                </div>
                <div className={styles.coverImage}>
                    <img
                        src={data.cover_image_url}
                        alt="Cover Image"
                        className={styles.image}
                    />
                </div>

                {data.user_id === id ? "" :
                    <DescriptionLight
                        text='Waiting for the host to start Quiz...'
                        size='55'
                        classes='mt-3'
                    />
                }
                <Accordian
                    header={
                        <div className='w-100 d-flex flex-row align-items-center justify-content-between'>
                            <Description
                                text='Contestants'
                                size='6'

                            />
                            <LabelHeader
                                text={<span className='d-flex flex-row align-items-center gap-1'>
                                    <span>{isFetching ? <Spinner size="sm" /> : (lobbyUsers?.data?.contestants.length || 0)}</span>
                                    <span>/</span>
                                    <span>{data.contestant_count || 0}</span>
                                </span>}
                            />
                        </div>
                    }

                    content={
                        isFetching ?
                            <div className='d-flex p-4 justify-content-center'><Spinner className='text-white' /></div> :
                            <LobbyUser
                                data={lobbyUsers.data.contestants?.map(item => item.user) || []}
                            />
                    }
                    classes='mt-3'
                />
                <Accordian
                    header={
                        <Description
                            text='Audience'
                            size='6'
                        />
                    }
                    content={
                        isFetching ?
                            <div className='d-flex p-4 justify-content-center'><Spinner className='text-white' /></div> :
                            <LobbyUser
                                data={lobbyUsers.data.audience?.map(item => item.user) || []}

                            />
                    }
                    classes='mt-2'
                />
                <Headline
                    classes='mt-2 mb-4'
                />

                {data.user_id !== id ?
                    <Button
                        lightTheme={true}
                        text='Leave Quiz'
                        onClick={handleLeaveQuiz}
                    />
                    :
                    <Button
                        text='Get Started'
                        onClick={handleStartQuiz}
                        isSubmitted={isSubmitted}
                    />
                }
            </div>
        </Container>
    )
}


const LobbyUser = ({ data = [] }) => {
    if (_.isEmpty(data)) {
        return <Description
            text='No user found.'
            classes='p-4 text-center'
        />
    }

    return (
        <div className={styles.userContainer}>
            {data?.map((item, index) => {
                return <div className={styles.user} key={item.id}>
                    <div className={styles.image}>
                        <img
                            src={item.image_url}
                            alt={'User Image ' + index}
                        />
                    </div>
                    <LabelHeader
                        text={item.name}
                        classes='lc-1'
                    />
                </div>
            }
            )}
        </div>
    )
}